import { render } from "./HandshakeIcon.vue?vue&type=template&id=16027ef2"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/HandshakeIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16027ef2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16027ef2', __exports__)) {
    api.reload('16027ef2', __exports__)
  }
  
  module.hot.accept("./HandshakeIcon.vue?vue&type=template&id=16027ef2", () => {
    api.rerender('16027ef2', render)
  })

}


export default __exports__